// /src/components/admin/InvitationReportsSection.jsx
// Content Moderation → Invitation reports (Roadmap #54, Invitations Build 2 §4, Phase 3): how many
// times each group's invitation emails were reported by their recipients. Stored only — no
// thresholds or response are built (§4). Platform admins only (get_invitation_report_counts checks
// is_platform_admin). English only, no translation keys: the Admin Panel ruling (Michael, 3 Oct 2026).

import React, { useState, useEffect } from 'react';
import { groupService } from '../../data/dataService';
import { tokens } from '../../styles/designTokens';

const InvitationReportsSection = ({ reload = 0 }) => {
  const [state, setState] = useState({ loading: true, error: false, rows: [] });

  useEffect(() => {
    let cancelled = false;
    setState(prev => ({ ...prev, loading: true }));
    groupService.getInvitationReportCounts().then(({ rows, error }) => {
      if (!cancelled) setState({ loading: false, error: !!error, rows });
    });
    return () => { cancelled = true; };
  }, [reload]);

  const cell = { padding: '8px 12px', borderBottom: `1px solid ${tokens.colors.disabledBackground}`, textAlign: 'left', fontSize: '14px' };

  if (state.loading) return <p style={{ color: tokens.colors.textSecondary }}>Loading invitation reports…</p>;
  if (state.error) return <p style={{ color: tokens.colors.destructive }}>Could not load invitation reports.</p>;
  if (state.rows.length === 0) return <p style={{ color: tokens.colors.textSecondary }}>No invitation has been reported.</p>;

  return (
    <div>
      <p style={{ color: tokens.colors.textSecondary, fontSize: '13px', margin: '0 0 12px' }}>
        Reports made from the “Report it” link in invitation emails, by sending group. A group that
        has since been deleted keeps its name here.
      </p>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={cell}>Group</th>
            <th style={cell}>Reports</th>
            <th style={cell}>Last report</th>
          </tr>
        </thead>
        <tbody>
          {state.rows.map(row => (
            <tr key={row.group_id || row.group_name}>
              <td style={cell}>{row.group_name}</td>
              <td style={cell}>{Number(row.reports)}</td>
              <td style={cell}>{row.last_report_at ? new Date(row.last_report_at).toLocaleString('en-GB') : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvitationReportsSection;
